import { GenericType } from "typescript";
import { User } from "../states/user";
import { extend } from "lodash";

export interface Transportation {
  id: string;
  loadingPoint?: TransportationLoadingPoint;
  workPoint?: TransportationWorkPoint;
  unloadingPoint?: TransportationUnloadingPoint;
  status?: TransportationStatus;
  ongoingTransportation?: OngoingTransportation;
  checkListLoadingPoint?: CheckListLoadingPoint;
  checkListWorkPoint?: CheckListWorkPoint;
  checkListUnloadingPoint?: CheckListUnloadingPoint;
  requester: string;
  requesterContact: string;
  paymentMethod: string;
  transportFee: number;
  memo: string;
  dispatchDate: Date;
  createdAt: Date;
  updatedAt: Date;
}

/** 오더 상태 신규 추가  */
export interface TransportationType {
  status: string;
  transportation_id: string;
  admin_id: string;
  name: string;
  phone: string;
  email: string;
  business_number: string;
  company_name: string;
  main_contact_phone: string;
  transport_type: number;
  order_number: string;
  import_export: number;
  dispatch_request_date: string; // ISO 8601 formatted date
  container_no: string;
  container_spec: string;
  container_type: string;
  normal: boolean;
  fridge: boolean;
  danger: boolean;
  tank: boolean;
  toxic: boolean;
  direct_import: boolean;
  direct_shipment: boolean;
  forwarder: string;
  bl_no: string;
  bk_no: string;
  load_place_remark: string;
  work_place_remark: string;
  work_start_time: string; // ISO 8601 formatted date-time
  work_time: string;
  cargo_weight: string;
  point_manage_contact: any; // Can be null
  cargo_owner: string;
  return_date: string; // ISO 8601 formatted date
  cost: number;
  order_state: any;
  unload_place_remark: string;
  payment_method: number;
  received_company_id: any; // Can be null
  remark: any; // Can be null
  fee: any; // Can be null
  fee_unit: any; // Can be null
  final_settlement_amount: any; // 최종 정산금
  load_place: string;
  load_place_address: string;
  load_place_name: string;
  loading_point_completed: null | boolean;
  loading_point_img_completed: null | boolean;
  work_place?: string;
  work_place_address?: string;
  work_place_tel?: string;
  work_place_name?: string;
  work_point_completed?: boolean | null;
  work_point_img_completed?: boolean | null;
  unload_place: string;
  unload_place_address: string;
  unload_place_name: string;
  unloading_point_completed: boolean | null;
  unloading_point_img_completed: boolean | null;
  transportation_status: string | null;
  is_required_receipt?: boolean | null;
}

export interface OrderType {
  admin_id: string;
  name: string;
  phone: string;
  email: string;
  business_number: string;
  company_name: string;
  main_contact_phone: string;
  transport_type: number;
  order_number: string;
  import_export: number;
  dispatch_request_date: Date;
  container_no: string;
  container_spec: any | string;
  container_type: string;
  normal: boolean;
  fridge: boolean;
  danger: boolean;
  tank: boolean;
  toxic: boolean;
  direct_import: boolean;
  direct_shipment: boolean;
  forwarder: any | string;
  bl_no: any | string;
  bk_no: any | string;
  load_place_remark: any | string;
  work_place_remark: any | string;
  work_start_time: string;
  work_time: any | string;
  cargo_weight: any | string;
  point_manage_contact: any | string;
  cargo_owner: any | string;
  return_date: Date;
  cost: number;
  order_state: string;
  unload_place_remark: any | string;
  payment_method: number;
  received_company_id: any;
  remark: any;
  fee: number;
  fee_unit: string;
  final_settlement_amount: number;
  load_place: string;
  load_place_address: string;
  load_place_name: string;
  work_place?: string;
  work_place_address?: string;
  work_place_tel?: string;
  work_place_name?: string;
  unload_place: string;
  unload_place_address: string;
  unload_place_name: string;
  user_id: any;
  completed_date: Date | string;
  transportation_status: string | null;
  is_required_invoice: boolean | null; // 인수증 필수 여부
  driver_vehicle_number?: string;
}

export interface TransportationLoadingPoint {
  id: string;
  transportation: Transportation;
  address: string;
  terminalName: string;
  carrier: string;
  containerSpecification: string;
  containerType: string;
  memo: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface TransportationWorkPoint {
  id: string;
  transportation: Transportation;
  address: string;
  companyName: string;
  companyPhoneNumber: string;
  consignorName: string;
  cargoWeight: number;
  workTime: Date;
  memo: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface TransportationUnloadingPoint {
  id: string;
  transportation: Transportation;
  address: string;
  terminalName: string;
  memo: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface TransportationStatus {
  id: string;
  transportation: Transportation;
  user: User[];
  status: TransportationStatusType;
}

export interface OngoingTransportation {
  id: string;
  user: User;
  transportation: Transportation;
  startTime: Date;
}

export interface CheckListLoadingPoint {
  id: string;
  transportation: Transportation;
  isImgCompleted: boolean;
  isCompleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface CheckListWorkPoint {
  id: string;
  transportation: Transportation;
  isImgCompleted: boolean;
  isCompleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface CheckListUnloadingPoint {
  id: string;
  transportation: Transportation;
  isImgCompleted: boolean;
  isCompleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface CheckListImageType extends ImageType {
  transportationId: string;
  isImgCompleted: boolean;
  isCompleted: boolean;
  traansportationType: number;
}

export interface ImageType {
  imagename?: string;
  size?: string;
  imageUrl?: string;
  updatedAt?: Date;
}

export interface SearchType {
  data: string;
  point: string;
  // loadingPoint?: Array<{ data: string; point: string }>;
  // workPoint?: Array<{ data: string; point: string }>;
  // unloadingPoint?: Array<{ data: string; point: string }>;
}

export enum TransportationStatusType {
  STANDBY = "STANDBY", // 준비
  WAITING = "WAITING", // 대기
  EN_ROUTE_TO_LOADING_POINT = "EN_ROUTE_TO_LOADING_POINT", // 상차지 이동
  LOADING_COMPLETED = "LOADING_COMPLETED", // 상차 완료
  EN_ROUTE_TO_WORK_POINT = "EN_ROUTE_TO_WORK_POINT", // 작업지 이동
  WORK_COMPLETED = "WORK_COMPLETED", // 작업 완료
  EN_ROUTE_TO_UNLOADING_POINT = "EN_ROUTE_TO_UNLOADING_POINT", // 하차지 이동
  UNLOADING_COMPLETED = "UNLOADING_COMPLETED", // 하차 완료
  TRANSPORTATION_CANCEL_REQUEST = "TRANSPORTATION_CANCEL_REQUEST", // 운송 취소 요청
  COMPLETED = "COMPLETED", // 완료
  CANCELLED = "CANCELLED", // 취소
}

export interface VehicleInfoRegistrationType {
  vehicleNumber: string;
  vehicleType: string;
  standard: string;
  chassis: string;
  vehicleFeatures: VehicleFeature[];
}

export enum VehicleFeature {
  DANGEROUS_GOODS = "DANGEROUS_GOODS", // 위험물
  BOND_MOVEMENT = "BOND_MOVEMENT", // 보세운송
  GENERATOR = "GENERATOR", // 발전기
  REFRIGERATED = "REFRIGERATED", // 냉장
  FROZEN = "FROZEN", // 냉동
}
export interface TransportationPerformanceType {
  currentMonthCount: number;
  countPercentage: number;
  currentMonthAmount: number;
  amountPercentage: number;
}
